<template>
  <div class="main-wrapper">
    <div style="height: 10px"></div>
    <el-row :gutter="20">
      <el-col :span="20">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="类型">
            <el-select v-model="formInline.status" placeholder="工单状态">
              <el-option
                v-for="status in getAllTicketStatus()"
                :key="status"
                :label="getTicketStatus(status)"
                :value="status"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单编号">
            <el-input v-model="formInline.ticketNo" placeholder="工单编号"></el-input>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="btnSearchClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button type="warning" @click="btnAddClick">创建工单</el-button>
      </el-col>
    </el-row>

    <el-table :data="tickets" style="width: 100%">
      <el-table-column label="工单编号" width="100">
        <template #default="scope">
          <el-link type="primary" :class="getClassName(scope.row)" :underline="false" @click.prevent="btnViewClick(scope.row)">
            {{ scope.row.ticketNo }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="问题内容">
        <template #default="scope">
          <el-link type="primary" :class="getClassName(scope.row)" :underline="false" @click.prevent="btnViewClick(scope.row)">
            <span v-if="isUnread(scope.row)">【未读】</span>
            {{ scope.row.content }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="工单类型" align="center" width="150">
      <template #default="scope">
        <span :class="getClassName(scope.row)">
          {{ getTicketCategory(scope.row) }}
        </span>
      </template>
    </el-table-column>
      <el-table-column label="提交时间" align="center" width="145">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ scope.row.createdDate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="140">
        <template #default="scope">
          <el-tag :class="getClassName(scope.row)" :type="getTicketStatusType(scope.row)">
            {{ getTicketStatus(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="优先级" align="center" width="140">
        <template #default="scope">
          <span :class="getClassName(scope.row)">
            {{ getTicketPriority(scope.row.priority) }}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        v-on:current-change="handleCurrentChange"
        :current-page="formInline.currentPage"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </div>

    <el-drawer title="提交工单" direction="rtl" size="60%" v-model="isAdd">
      <ticket-add v-if="isAdd" @close="handleTicketAddClose"></ticket-add>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { ITicket } from '@/types/models';
import api, { IGetRequest } from '@/api/my/tickets';
import { PER_PAGE } from '@/const';
import utils from '@/utils';
import { TicketPriority, TicketStatus } from '@/types/enums';
import TicketAdd from './components/tickets/TicketAdd.vue';

interface IForm extends IGetRequest {
  currentPage: number;
}

interface IState {
  isTicket: boolean;
  count: number;
  tickets: ITicket[];
  isAdd: boolean;
  formInline: IForm;
}

export default defineComponent({
  components: { TicketAdd },
  name: 'Tickets',
  data() {
    return {
      isTicket: false,
      count: 0,
      tickets: [],
      isMessages: false,
      messagesCount: 0,
      messages: [],
      isAdd: false,
      formInline: {
        status: TicketStatus.All,
        ticketNo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.isTicket = res.isTicket;
        this.count = res.count;
        this.tickets = res.tickets;
      });
    },

    getAllTicketStatus() {
      return Object.values(TicketStatus);
    },

    getTicketStatusType(ticket: ITicket) {
      if (ticket.status === TicketStatus.Closed) {
        return 'success';
      }
      if (ticket.status === TicketStatus.Dealing) {
        return 'info';
      }
      return 'danger';
    },

    getTicketCategory(ticket: ITicket) {
      return utils.getTicketCategory(ticket.category);
    },

    getTicketStatus(status: TicketStatus) {
      return utils.getTicketStatus(status);
    },

    getTicketPriority(status: TicketPriority) {
      return utils.getTicketPriority(status);
    },

    btnSearchClick() {
      this.apiGet();
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },

    btnAddClick() {
      if (this.isTicket) {
        this.isAdd = true;
      } else {
        Swal.fire({
          title: '提交工单',
          text: '系统检测到您尚未存在订单（网站云、模板、插件），暂无法提交工单！',
          icon: 'warning',
          confirmButtonText: '关 闭',
          showConfirmButton: true,
          showCancelButton: false,
          customClass: {
            confirmButton: 'el-button el-button--danger',
            cancelButton: 'el-button el-button--default',
          },
          buttonsStyling: false,
        });
      }
    },

    btnViewClick(ticket: ITicket) {
      ticket.isRead = true;
      utils.pageOpen(`/my/tickets/${ticket.ticketNo}`);
    },

    isUnread(ticket: ITicket) {
      return ticket.status === TicketStatus.Waiting && !ticket.isRead;
    },

    getClassName(ticket: ITicket) {
      if (ticket.status === TicketStatus.Waiting && !ticket.isRead) {
        return 'unread';
      }
      return '';
    },

    handleTicketAddClose(isFresh: boolean) {
      this.isAdd = false;
      if (isFresh) {
        this.formInline.status = TicketStatus.All;
        this.formInline.offset = 0;
        this.apiGet();
      }
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
